import { useState, useEffect, useCallback } from 'react';
import { apiClient } from '../utils/api';
import { useAuth } from '../auth/AuthContext';

export function useChUtilData(mac, interval, customRange = null) {
    const [data, setData] = useState(null);
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState(null);
    const { hasPermission } = useAuth();
    const canView = hasPermission('devices:read');

    const fetchData = useCallback(async () => {
        if (!mac || !interval || !canView) {
            setData(null);
            return;
        }

        setLoading(true);
        setError(null);

        try {
            const extraParams = {};
            if (interval === 'custom' && customRange?.start && customRange?.end) {
                extraParams.dt_start = customRange.start;
                extraParams.dt_end = customRange.end;
            }

            const response = await apiClient.getChUtilMetrics(mac, interval, extraParams);
            setData(response);
        } catch (err) {
            const message = err.message || 'Failed to fetch channel utilization data';
            console.error('Channel Util Fetch Error:', err);
            setError(message);
            setData(null);
        } finally {
            setLoading(false);
        }
    }, [mac, interval, customRange, canView]);

    useEffect(() => {
        fetchData();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [mac, interval, customRange?.start, customRange?.end, canView]);

    return { data, loading, error, refresh: fetchData };
}
